import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
})
export class GameComponent implements OnInit {
  tooltipTitle =
    'De tijd loopt! Beweeg met uw muis over het scherm en zoek uw gekozen product.';

  isRedirected = false;

  constructor(private router: Router) {}

  ngOnInit() {
    let body = document.body;
    body.classList.add('game');

    // countdown
    let minuteCounter = document.getElementById('minute-counter--time');
    let timeLeft = 59;

    setInterval(function () {
      minuteCounter.innerHTML = timeLeft.toString();
      timeLeft--;

      if (timeLeft < -5 && !this.isRedirected) {
        this.router.navigate(['/result']);
        this.isRedirected = true;
      }
    }, 1000);

    // redirect after 60s
    setTimeout(() => {
      if (!this.isRedirected) {
        this.router.navigate(['/result']);
        this.isRedirected = true;
      }
    }, 60000);
  }

  ngOnDestroy() {
    let body = document.body;
    body.classList.remove('game');
  }
}
